'use strict';
function numberFormat(number, decimals = 0, dec_point = ',', thousands_sep = ' ') {
  var i, j, kw, kd, km;
  i = parseInt(number = (+number || 0).toFixed(decimals)) + "";
  if ((j = i.length) > 3) {
    j = j % 3;
  } else {
    j = 0;
  }
  km = (j ? i.substr(0, j) + thousands_sep : "");
  kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
  kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");
  return km + kw + kd;
}
function jsonRequest(url, method = 'GET', data = [], callback = null) {
  if (method !== 'GET') {
    var token = $('meta[name="csrf-token"]').attr('content');
    if (Array.isArray(data)) {
      data.push({name: '_token', value: token});
    } else if (typeof(data) === 'object') {
      data['_token'] = token;
    }
  }
  $('body').addClass('loading');
  $.ajax({
    url:      url,
    data:     data,
    method:   method,
    dataType: 'json',
    timeout:  30000,
    success: function (data) {
      $('body').removeClass('loading');
      if (callback) {
        callback(data);
      }
    },
    error: function (data, status, error) {
      $('body').removeClass('loading');
      if (callback) {
        callback({success: false, error_code: status});
      }
    },
  });
}
function changeCart(id, add = 1, equals = false) {
  add = parseInt(add) || 0;
  jsonRequest('/buy/cart.json', 'GET', {}, function (cart) {
    if (cart && cart.success) {
      var value = parseInt(cart['cart'][id]) || 0;
      if (equals) {
        value = add;
      } else {
        value += add;
        if (value < 0) {
          value = 0;
        }
      }
      jsonRequest('/buy/cart.json', 'POST', {id: id, quantity: value}, function (data) {
        if (data && data.success) {
          updateCart();
        } else {
          console.error(data);
        }
      });
    } else {
      console.error(cart);
    }
  });
}
function changeFavs(id) {
  jsonRequest('/buy/favs.json', 'GET', {}, function (favs) {
    if (favs && favs.success) {
      var oldValue = parseInt(favs['favs'][id]) || 0;
      var newValue = oldValue > 0 ? 0 : 1;
      jsonRequest('/buy/favs.json', 'POST', {id: id, value: newValue}, function (data) {
        if (data && data.success) {
          updateFavs();
        } else {
          console.error(data);
        }
      });
    } else {
      console.error(favs);
    }
  });
}
function updateCart() {
  jsonRequest('/buy/cart.json', 'GET', {}, function (cart) {
    var total = 0;
    $.each(cart['cart'], function (key, value) {
      total += parseInt(value) || 0;
    });
    $('.cart-total-quantity').html(total);
    if (total > 0) {
      $('.cart-total-quantity').removeClass('d-none');
    } else {
      $('.cart-total-quantity').addClass('d-none');
    }
    $('.products-cart-item').each(function () {
      var id    = $(this).data('id');
      var value = parseInt(cart['cart'][id]) || 0;
      var price = parseInt($(this).find('.products-cart-price').find('.value').data('value')) || 0;
      $(this).find('.products-cart-quantity input').val(value);
      $(this).find('.products-cart-subtotal .value').removeClass('loading').html(numberFormat(value*price));
    });
    $('.products-cart-total > .value').removeClass('loading').html(numberFormat(cart['totals']['total']));
    $('.products-cart-discount > .value').removeClass('loading').html(numberFormat(cart['totals']['discount']));
    $('.products-cart-dtotal > .value').removeClass('loading').html(numberFormat(cart['totals']['dtotal']));
    
    $('.btn-to-cart').each(function () {
      var id    = $(this).data('id');
      var value = parseInt(cart['cart'][id]) || 0;
      if (value > 0) {
        $(this).addClass('active').attr('title', 'В корзину').children('span').html('В корзине <span class="badge">'+value+'</span>');
      } else {
        $(this).removeClass('active').attr('title', 'В корзину').children('span').html('В корзину');
      }
    });
  });
}
function updateFavs() {
  jsonRequest('/buy/favs.json', 'GET', {}, function (favs) {
    var total = 0;
    $.each(favs['favs'], function(key, value) {
      if (value > 0) {
        total++;
      }
    }); 
    $('.favs-total-quantity').html(total);
    if (total > 0) {
      $('.favs-total-quantity').removeClass('d-none');
    } else {
      $('.favs-total-quantity').addClass('d-none');
    }

    $('.btn-to-favs').each(function () {
      var id    = $(this).data('id');
      var value = parseInt(favs['favs'][id]) || 0;
      if (value > 0) {
        $(this).addClass('active').attr('title', 'Убрать из отложенных').children('span').html('Убрать из отложенных');
      } else {
        $(this).removeClass('active').attr('title', 'Отложить').children('span').html('Отложить');
      }
    });
  });
}
$(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  }).trigger('scroll');
  $('.nav-item-search').html($('.navbar-search').html());
  $('input[type="tel"]').each(function () {
    $(this).prop('placeholder', '+7 XXX XXX-XX-XX');
  }).on('input', function () {
    var value = $(this).val().replace(/\D/g, '');
    value = value.replace(/^8/, '7');
    value = value.replace(/^9/, '79');
    value = value.replace(/^7(\d)/, '7 $1');
    value = value.replace(/^7 (\d{3})(\d)/, '7 $1 $2');
    value = value.replace(/^7 (\d{3}) (\d{3})(\d)/, '7 $1 $2-$3');
    value = value.replace(/^7 (\d{3}) (\d{3})-(\d{2})(\d)/, '7 $1 $2-$3-$4');
    $(this).val(value === '' ? '' : '+' + value);
  }).trigger('input');
  $('iframe:not(.no-wrap)').each(function () {
    if ($(this).parents('.no-wrap').length > 0) {
      return;
    }
    $(this).addClass('embed-responsive-item').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
  });
  $('.slider-product').slick({
    dots:           true,
    infinite:       true,
    speed:          200,
    slidesToShow:   1,
    adaptiveHeight: true,
  });
  $('.slider').magnificPopup({
    tClose: 'Закрыть',
    tLoading: 'Загрузка...',
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnContentClick: true,
    closeBtnInside: false,
    removalDelay: 300,
    delegate: '.slick-slide:not(.slick-cloned) img',
    callbacks: {
      elementParse: function(img) {
        img.src = img.el.attr('src');
      },
    },
    image: {
      verticalFit: true,
      tError: 'Невозможно загрузить изображение',
    },
    gallery: {
      enabled: true,
      preload: [0,2],
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      tPrev: 'Назад',
      tNext: 'Вперед',
      tCounter: '<span class="mfp-counter">%curr% / %total%</span>'
    },
  });
  $('.form-calc .btn-calc-add').click(function () {
    var $parent = $(this).parents('.form-calc');
    var $target = $parent.find('.form-calc-action');
    var total   = parseInt($parent.find('.form-calc-group').last().data('number')) || 0;
    var $field  = $parent.find('.form-calc-group').first().clone(true);
    total++;
    $field.removeClass('d-none').attr('data-number', total).find('label').html($field.find('label').html() + ' ' + total);
    $field.insertBefore($target);
  });
  $('.form-calc .btn-calc-remove').click(function () {
    $(this).parents('.form-calc-group').remove();
  });
  $('.form-calc .btn-calc-result').click(function (event) {
    event.preventDefault();
    $('body').addClass('loading');
    var $parent  = $(this).parents('.form-calc');
    var $target  = $parent.find('.form-calc-result');
    var type     = $parent.data('calc');
    var items    = [];
    var left     = [];
    var split    = 0;
    var quantity = 0;
    var lengths = {
      '3000L':   3000,
      '3500':    3500,
      '7000':    7000,
      '7000L':   7000,
      'tektrak': 2500,
      'tekside': 7000,
      'br':      2142,
    };
    var heights = {
      '3000L':   305,
      '3500':    306,
      '7000':    306,
      '7000L':   305,
      'tektrak': 150,
      'tekside': 200,
      'br':      400,
    };
    $target.addClass('d-none');
    $parent.find('.form-calc-group').each(function () {
      if ($(this).hasClass('d-none')) {
        return;
      }
      var
        width  = parseInt($(this).find('input[name="width[]"]').val())  || 0,
        height = parseInt($(this).find('input[name="height[]"]').val()) || 0;
      if (!width || !height) {
        return;
      }
      var
        length = (type == 'br' ? height : width),
        lines  = (type == 'br' ? width  : height);
      if (type == 'br') {
        lines = lines > 240 ? Math.floor((lines - 240)/heights[type]) + 2 : 1;
      } else if (type != 'tektrak') {
        lines = Math.ceil(lines/heights[type]);
      }
      quantity += lines*Math.floor(length/lengths[type]);
      length    = length % lengths[type];
      if (length > 0) {
        for (var i = 0; i < lines; i++) {
          items.push(length);
        }
      }
    });
    items.sort().reverse();
    items.forEach(function (value, index) {
      var found = false;
      left.sort();
      left.forEach(function (value2, index2) {
        if (value2 >= value) {
          left[index2] = value2 - value - split;
          found = true;
          return false;
        }
        value -= value2;
        items[index] = value;
        left[index2] = 0;
      });
      if (!found) {
        quantity++;
        left.push(lengths[type] - value - split);
      }
    });
    $target.find('.form-calc-quantity').html(quantity);
    $target.find('.btn-to-cart').attr('data-quantity', quantity);
    if (quantity > 0) {
      $target.find('.btn-to-cart').removeClass('d-none');
    } else {
      $target.find('.btn-to-cart').addClass('d-none');
    }
    $target.removeClass('d-none');
    $('body').removeClass('loading');
    return false;
  });
  $('.form-calc').each(function () {
    $(this).find('.btn-calc-add').trigger('click');
  });
  $('form[method="post"]').submit(function () {
    $(this).find(':input').addClass('disabled').prop('readonly', true);
    $(this).find('button').prop('disabled', true);
    $('body').addClass('loading');
  });
  $('.form-ajax').submit(function (e) {
    e.preventDefault();
    var $form = $(this);
    $form.find('.alert').remove();
    data = $form.serializeArray();
    data.push({name: 'gaRa', value: 'geTEK'});
    data.push({name: 'page_url', value: window.location.href});
    jsonRequest($form.attr('action'), $form.attr('method'), data, function (data) {
      $form.find(':input').removeClass('disabled').prop('readonly', false);
      $form.find('button').prop('disabled', false);
      if (data && data.success) {
        $form[0].reset();
        $('<div>').addClass('alert-body').html(data.message ? data.message : 'Форма успешно отправлена').wrap('<div>').parent().addClass('alert alert-success').prependTo($form);
      } else {
        console.error(data);
        $('<div>').addClass('alert-body').html(data.message ? data.message : 'Неизвестная ошибка ['+(data.error_code ? data.error_code : 'unknown_error')+']').wrap('<div>').parent().addClass('alert alert-danger').prependTo($form);
      }
    });
    return false;
  });
  $('.btn-to-cart').click(function (e) {
    e.preventDefault();
    var id  = $(this).data('id');
    var add = parseInt($(this).data('quantity')) || 1;
    changeCart(id, add);
    return false;
  });
  $('.btn-to-favs').click(function (e) {
    e.preventDefault();
    changeFavs($(this).data('id'));
    return false;
  });
  $('.products-cart-more').click(function (e) {
    e.preventDefault();
    var id = $(this).parents('.products-cart-item').data('id');
    changeCart(id, 1);
    return false;
  });
  $('.products-cart-less').click(function (e) {
    e.preventDefault();
    var id = $(this).parents('.products-cart-item').data('id');
    changeCart(id, -1);
    return false;
  });
  $('.products-cart-quantity > input').on('input', function () {
    var id    = $(this).parents('.products-cart-item').data('id');
    var value = $(this).val();
    value = value.replace(/\D/iug, '');
    value = value.replace(/^0/iug, '');
    if (value == '') {
      value = '0';
    }
    $(this).val(value);
    changeCart(id, value, true);
    return false;
  });
  $('.products-cart-remove').click(function (e) {
    e.preventDefault();
    var $target = $(this).parents('.products-cart-item');
    changeCart($target.data('id'), 0, true);
    $target.remove();
    return false;
  });
  $('.btn-confirm').click(function (e) {
    var text = $(this).data('text') || 'Вы уверены?';
    if (!confirm(text)) {
      e.preventDefault();
      return false;
    }
  });
  $('.form-control-code').on('input', function () {
    if ($(this).val().trim().length >= 6) {
      $(this).parents('form').submit();
    }
  });
  $('option[value=""]').prop('disabled', true);
  $('.form-group-delivery select, .form-group-address input').change(function () {
    var
      $form       = $(this).parents('form'),
      delivery_id = $form.find('[name="delivery_id"]').val(),
      address     = $form.find('[name="address"]').val();
      jsonRequest('/buy/cart.json', 'GET', {}, function (cart) {
        var total = cart && cart['success'] ? (cart['totals']['dtotal'] ? cart['totals']['dtotal'] : cart['totals']['total']) : null;
        jsonRequest('/cart/order/delivery.json', 'GET', {delivery_id: delivery_id, address: address}, function (delivery) {
          var price = delivery && delivery['success'] ? delivery['price'] : null;
          if (price === null) {
            $form.find('.products-cart-delivery > .name + span').removeClass('value').removeClass('loading').addClass('text').html('под расчет');
            $form.find('.products-cart-sum > .value').removeClass('loading').html(numberFormat(total));
          } else if (price === 0) {
            $form.find('.products-cart-delivery > .name + span').removeClass('value').removeClass('loading').addClass('text').html('бесплатно');
            $form.find('.products-cart-sum > .value').removeClass('loading').html(numberFormat(total));
          } else {
            $form.find('.products-cart-delivery > .name + span').removeClass('text').removeClass('loading').addClass('value').html(numberFormat(price));
            $form.find('.products-cart-sum > .value').removeClass('loading').html(numberFormat(total + price));
          }
        });
      });
  });
  $('.form-group-delivery select').on('change', function () {
    var $form = $(this).parents('form');
    if ($(this).val() == '1') {
      $form.find('.form-group-store').removeClass('d-none');
      $form.find('.form-group-address').addClass('d-none');
    } else {
      $form.find('.form-group-store').addClass('d-none');
      $form.find('.form-group-address').removeClass('d-none');
    }
    if ($(this).val() == '6') {
      $form.find('.products-cart-delivery-text').removeClass('d-none');
    } else {
      $form.find('.products-cart-delivery-text').addClass('d-none');
    }
  }).trigger('change');
  $('.table-collapse').each(function () {
    var cols = [];
    $(this).find('thead tr').last().find('th, td').each(function () {
      cols.push($(this).text());
    });
    $(this).find('tbody tr').each(function () {
      $(this).find('th, td').each(function (ind) {
        $(this).attr('data-title', cols[ind]);
      });
    });
  });
  $('[data-toggle="tooltip"]').tooltip();
  updateCart();
  updateFavs();
  $('body').removeClass('loading');
});